import { Button, Col, Row, Tabs } from "antd";
import React from "react";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";
import CustomModal from "./Modals/CustomModal";
import AugerStateView from "./Diagnostics/AugerStateView";
import FanStateView from "./Diagnostics/FanStateView";
import HeadspaceStateView from "./Diagnostics/HeadspaceStateView";

interface DiagnosticViewModalProps {
    show: boolean;
    onClose: () => void;
    binDto: PremierPlusBinDTO | null | undefined;
    parentRef?: React.RefObject<HTMLElement>;
}

const tabLabel = (text: string) => (
    <span style={{ fontSize: 16, fontWeight: 500, padding: '10px 8px', display: 'inline-block' }}>
        {text}
    </span>
);

const DiagnosticViewModal: React.FC<DiagnosticViewModalProps> = ({ show, onClose, binDto, parentRef }) => {
    const binState = binDto?.binState;

    return (
        <CustomModal
            show={show}
            onClose={onClose}
            title="DIAGNOSTIC VIEW"
            parentRef={parentRef}
            panelWidth={680}
        >
            <Tabs
                defaultActiveKey="augers"
                size="large"
                items={[
                    {
                        key: 'augers',
                        label: tabLabel('Augers & Machine'),
                        children: (
                            <AugerStateView
                                augers={binState?.augerStates}
                                isMachineOn={binState?.isMachineOn ?? binDto?.isMachineOn}
                                machineCurrent={binState?.machineCurrentSensorState}
                            />
                        ),
                    },
                    {
                        key: 'fans',
                        label: tabLabel('Fans'),
                        children: <FanStateView fanStates={binState?.fanStates} />,
                    },
                    {
                        key: 'gams',
                        label: tabLabel('GAMs'),
                        children: <HeadspaceStateView gamStates={binState?.grainAnalyticsModuleStates} />,
                    },
                ]}
            />
            <Row justify="end" style={{ marginTop: 8 }}>
                <Col span={6}>
                    <Button onClick={onClose} block type="primary">CLOSE</Button>
                </Col>
            </Row>
        </CustomModal>
    );
};

export default DiagnosticViewModal;
